import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { useBrand, brandLogo } from "../../lib/brand";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Mail, ArrowLeft } from "lucide-react";

export default function AdminForgotPassword() {
  const brand = useBrand();
  const logoLight = brandLogo(brand, "light");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      // Always show the same confirmation, regardless of whether email exists
      setSent(true);
    } catch {
      // Never leak failure detail — keep the same confirmation
      setSent(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#22302E] text-white flex items-center justify-center px-6 font-admin" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          {logoLight ? (
            <img src={logoLight} alt="Azuhomes" className="h-14 mx-auto" />
          ) : (
            <div className="font-display text-4xl tracking-tight text-white">Azuhomes</div>
          )}
          <div className="text-xs uppercase tracking-[0.32em] text-[#3B9FD4] mt-4">Recuperação de senha</div>
        </div>

        <div className="bg-white text-[#22302E] rounded-md p-8 shadow-2xl">
          {sent ? (
            <div data-testid="forgot-password-success">
              <div className="flex items-center gap-2 text-[#0AA89C]">
                <Mail className="w-5 h-5" />
                <h1 className="text-xl font-semibold">Verifique seu e-mail</h1>
              </div>
              <p className="text-sm text-[#22302E]/75 mt-4 leading-relaxed">
                Se este e-mail estiver cadastrado no sistema, enviamos um link para redefinição de senha.
                O link permanece válido pelos próximos 60 minutos e pode ser usado uma única vez.
              </p>
              <p className="text-xs text-[#22302E]/60 mt-3">
                Se você não recebeu a mensagem em alguns minutos, verifique a caixa de spam ou entre em contato com o Diretor da Azuhomes.
              </p>
              <Link to="/admin/login" className="mt-6 inline-flex items-center gap-2 text-sm text-[#0AA89C] hover:text-[#066B63]">
                <ArrowLeft className="w-4 h-4" /> Voltar ao login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="forgot-password-form">
              <div className="mb-6">
                <div className="flex items-center gap-2 text-[#0AA89C]">
                  <Mail className="w-5 h-5" />
                  <h1 className="text-xl font-semibold">Esqueci minha senha</h1>
                </div>
                <p className="text-sm text-[#22302E]/70 mt-1">Informe o e-mail cadastrado e enviaremos um link para redefinir a senha.</p>
              </div>
              <div>
                <Label htmlFor="fp-email">E-mail</Label>
                <Input
                  id="fp-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  data-testid="forgot-password-email"
                />
              </div>
              <Button type="submit" disabled={loading} className="w-full mt-6 bg-[#0AA89C] hover:bg-[#066B63] text-white" data-testid="forgot-password-submit">
                {loading ? "Enviando..." : "Enviar link de recuperação"}
              </Button>
              <div className="mt-4 text-center">
                <Link to="/admin/login" className="text-xs text-[#0AA89C] hover:text-[#066B63] inline-flex items-center gap-1">
                  <ArrowLeft className="w-3 h-3" /> Voltar ao login
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
